import { PaginatorComponent } from 'src/app/_forms/paginator/paginator.component';
import { AppBaseDataService } from 'src/app/_services/app-base-data.service';
import { formatDate } from '@angular/common';
import { Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { Paginator } from 'primeng/paginator';
import { BaseService } from 'src/app/_services/base.service';
import { GlobalService } from 'src/app/_services/global.service';
import { ReportsService } from 'src/app/_services/reports.service';
import { environment } from 'src/environments/environment';
import { HttpParams } from '@angular/common/http';
import { FilterServiceService } from 'src/app/_services/filter-service.service';

const SALES_INVOICES_TEMPLATE = `
<p-overlayPanel
    #op
    [style]="{ 'min-width': '200px', padding: '-20px', margin: '-20px' }"
>
    <ng-template pTemplate>
        <!-- <div class="conn-grid" style="margin-top: 1px"> -->
        <div></div>
        <button pButton pRipple type="button" 
        label="View" class="p-button-text" [style]="{ width: '100%' }"
            icon="pi pi-eye" iconPos="right" (click)="ViewCustomer()"></button>
        <!-- </div> -->
    </ng-template>
</p-overlayPanel>
<div class="conn-card" *ngIf="1 == 1">
    <app-report-top-filter-bar
        [paraReportName]="'sales-invoices'"
        (filterCallbackFunc)="callbackFuncFromFilter($event)"
        (filterCallbackFuncUpdateFilter)="filterButtonPressed()"
        (exportExcelFn)="exportExcel()"
        (exportPdfFn)="exportPdf()"
        (exportCsvFn)="dt.exportCSV()"
    ></app-report-top-filter-bar>

    <br />

    <!-- View Toggle Buttons -->
    <div class="flex gap-2 mb-3" *ngIf="isLoading || dataList?.length > 0">
        <button pButton pRipple type="button" icon="pi pi-list" 
            [class.p-button-outlined]="viewMode !== 'table'"
            [class.p-button-primary]="viewMode === 'table'"
            (click)="viewMode = 'table'" title="Table View"></button>
        <button pButton pRipple type="button" icon="pi pi-th-large" 
            [class.p-button-outlined]="viewMode !== 'card'"
            [class.p-button-primary]="viewMode === 'card'"
            (click)="viewMode = 'card'" title="Card View"></button>
    </div>

    <br />

    <!-- Table View -->
    <p-table
        #dt
        [columns]=""
        styleClass="p-datatable-striped"
        [autoLayout]="true"
        [tableStyle]="{ width: 'max-content' }"
        [value]="isLoading ? skeletonRows : dataList"
        responsiveLayout="scroll"
        [showLoader]="false"
        rowHover="true"
        [customSort]="true"
        selectionMode="single"
        [(selection)]="selectedRow"
        dataKey="invoiceNumber"
        (onRowSelect)="onRowSelected($event)"
        [lazy]="true"
        (onLazyLoad)="customSort($event)"
        *ngIf="(isLoading || dataList?.length > 0) && viewMode === 'table'"
    >
        <ng-template pTemplate="header">
            <tr>
                <th pSortableColumn="invoiceNumber">Order #<p-sortIcon field="invoiceNumber"></p-sortIcon></th>
                <th pSortableColumn="date">Date-Time<p-sortIcon field="date"></p-sortIcon></th>
                <th pSortableColumn="customer">Customer<p-sortIcon field="customer"></p-sortIcon></th>
                <th pSortableColumn="salesMode" style="justify-content: center">Mode<p-sortIcon field="salesMode"></p-sortIcon></th>
                <th pSortableColumn="transactionTypeString" style="justify-content: center">Txn Type<p-sortIcon field="transactionTypeString"></p-sortIcon></th>
                <th pSortableColumn="postedStatusString" style="justify-content: center">Status Type<p-sortIcon field="postedStatusString"></p-sortIcon></th>
                <th pSortableColumn="location">Location<p-sortIcon field="location"></p-sortIcon></th>
                <th pSortableColumn="register">Register<p-sortIcon field="register"></p-sortIcon></th>
                <th pSortableColumn="cashier">Cashier<p-sortIcon field="cashier"></p-sortIcon></th>
                <th style="text-align: right">Grand Total</th>
                <th style="text-align: center">Actions</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-item>
            <tr *ngIf="isLoading; else invoiceRow">
                <td><p-skeleton width="7rem" height="1rem"></p-skeleton></td>
                <td><p-skeleton width="11rem" height="1rem"></p-skeleton></td>
                <td><p-skeleton width="8rem" height="1rem"></p-skeleton></td>
                <td><p-skeleton width="5rem" height="1rem"></p-skeleton></td>
                <td><p-skeleton width="6rem" height="1rem"></p-skeleton></td>
                <td><p-skeleton width="6rem" height="1rem"></p-skeleton></td>
                <td><p-skeleton width="7rem" height="1rem"></p-skeleton></td>
                <td><p-skeleton width="6rem" height="1rem"></p-skeleton></td>
                <td><p-skeleton width="6rem" height="1rem"></p-skeleton></td>
                <td style="text-align: right"><p-skeleton width="5rem" height="1rem"></p-skeleton></td>
                <td><p-skeleton width="2rem" height="2rem" borderRadius="50%"></p-skeleton></td>
            </tr>
            <ng-template #invoiceRow>
                <tr [pSelectableRow]="item">
                    <td>{{ item.invoiceNumber }}</td>
                    <td>{{ item.date | date : "mediumDate" }} {{ item.time }}</td>
                    <td>{{ item.customer }}</td>
                    <td >{{ item.salesMode }}</td>
                    <td >{{ item.transactionTypeString }}</td>
                    <td >{{ item.postedStatusString }}</td>
                    <td>{{ item.location }}</td>
                    <td>{{ item.salesMode === 'Online' ? '-' : item.register }}</td>
                    <td>{{ item.salesMode === 'Online' ? '-' : item.cashier }}</td>
                    <td style="text-align: right">{{ item.purchase | currency | currencySpacing }}</td>
                    <td style="text-align: center">
                        <button
                            pButton
                            pRipple
                            type="button"
                            icon="pi pi-ellipsis-v"
                            class="p-button-rounded p-button-text"
                            (click)="actionButtonClick(item); op.toggle($event)"
                        ></button>
                    </td>
                </tr>
            </ng-template>
        </ng-template>
    </p-table>

    <!-- Card View -->
    <div class="grid" *ngIf="isLoading && viewMode === 'card'">
        <div *ngFor="let _ of skeletonRows">
            <div class="invoice-card p-3 border-round surface-card shadow-1 invoice-card-skeleton">
                <div class="card-header flex justify-content-between align-items-start mb-3">
                    <div>
                        <p-skeleton width="8rem" height="1rem" styleClass="mb-2"></p-skeleton>
                        <p-skeleton width="10rem" height="0.9rem"></p-skeleton>
                    </div>
                    <p-skeleton width="5rem" height="1.3rem"></p-skeleton>
                </div>
                <div class="card-body">
                    <div class="card-detail mb-2" *ngFor="let __ of [1,2,3,4,5]">
                        <p-skeleton width="30%" height="0.9rem"></p-skeleton>
                        <p-skeleton width="60%" height="0.9rem"></p-skeleton>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="grid" *ngIf="!isLoading && dataList?.length > 0 && viewMode === 'card'">
        <div *ngFor="let item of dataList">
            <div class="invoice-card">
                <!-- Card Header -->
                <div class="card-header flex align-items-center gap-2">
                    <span class="conn-flex-image-first-letter">{{ item.invoiceNumber | slice : 0 : 1 }}</span>
                    <div class="flex-grow-1">
                        <div class="font-semibold">#{{ item.invoiceNumber }}</div>
                        <div class="card-contact">
                            <span>{{ item.date | date : "mediumDate" }} {{ item.time }}</span>
                        </div>
                    </div>
                    <button pButton pRipple type="button" icon="pi pi-eye"
                        class="p-button-rounded p-button-text card-view-btn"
                        title="View"
                        (click)="actionButtonClick(item); ViewCustomer(); $event.stopPropagation()"></button>
                </div>

                <!-- Card Body -->
                <div class="card-body pt-2">
                    <div class="card-detail mb-2">
                        <div class="detail-label">Customer:</div>
                        <div class="detail-value">{{ item.customer }}</div>
                    </div>
                    <div class="card-detail mb-2">
                        <div class="detail-label">Mode:</div>
                        <div class="detail-value">{{ item.salesMode }}</div>
                    </div>
                    <div class="card-detail mb-2">
                        <div class="detail-label">Transaction:</div>
                        <div class="detail-value">{{ item.transactionTypeString }}</div>
                    </div>
                    <div class="card-detail mb-2">
                        <div class="detail-label">Status:</div>
                        <div class="detail-value" [class.badge-active]="item.postedStatusString === 'Posted'" [class.badge-inactive]="item.postedStatusString !== 'Posted'">
                            {{ item.postedStatusString }}
                        </div>
                    </div>
                    <div class="card-detail mb-2">
                        <div class="detail-label">Location:</div>
                        <div class="detail-value">{{ item.location }}</div>
                    </div>
                    <div class="card-detail mb-2">
                        <div class="detail-label">Register:</div>
                        <div class="detail-value">{{ item.salesMode === 'Online' ? '-' : item.register }}</div>
                    </div>
                    <div class="card-detail mb-2">
                        <div class="detail-label">Cashier:</div>
                        <div class="detail-value">{{ item.salesMode === 'Online' ? '-' : item.cashier }}</div>
                    </div>
                    <div class="card-detail mb-2">
                        <div class="detail-label">Grand Total:</div>
                        <div class="detail-value">{{ item.purchase | currency | currencySpacing }}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- No Data Message -->
    <div class="flex" *ngIf="!isLoading && dataList?.length == 0">
        <div class="text-align-center" style="width: 100%">
            <span class="control-description text-muted text-align-center">
                No data found!</span
            >
        </div>
    </div>

    <!-- Paginator -->
    <div>
        <p-paginator
        #p
        [first]="first"
        *ngIf="!isLoading && dataList?.length>0"
        (onPageChange)="onPageChange($event)"
        [rows]="rows"
        [totalRecords]="totalRecords"
        [pageLinkSize]="isMobile ? 2 : 5"
        [rowsPerPageOptions]="[10, 25, 50, 100, 500, 1000]"
        [showCurrentPageReport]="true"
        currentPageReportTemplate="Page: {currentPage} of {totalPages}, Total Records: {totalRecords}"
    ></p-paginator>

</div>
`;

@Component({
  selector: 'app-sales-invoices',
  template: SALES_INVOICES_TEMPLATE,
  styleUrls: ['./sales-invoices.component.scss'],
})
export class SalesInvoicesComponent implements OnInit {
  @ViewChild('p', { static: false }) paginator: Paginator;
  @ViewChild('paginator', { static: false }) Apppaginator: PaginatorComponent
  _globals = GlobalService

  dataList: any = []
  isLoading = false
  skeletonRows = Array.from({ length: 8 }, (_, idx) => ({ id: `skeleton-${idx}` }))

  page = 0
  rows = 10
  first = 0
  totalRecords = 0

  //order
  orderParam = ''
  orderBy = ''

  selectedRow: any = ''
  viewMode: 'table' | 'card' = 'card'
  isMobile = window.innerWidth <= 576

  @HostListener('window:resize')
  onResize() {
    this.isMobile = window.innerWidth <= 576
  }
  selectedCardId: any = null

  colheader = [[
    'Order #', 'Date', 'Time', 'Customer', 'Mode', 'Txn Type', 'Status Type',
    'Location', 'Register', 'Cashier', 'Grand Total'
  ]];

  colflds = ['invoiceNumber', 'datedLocal', 'time', 'customer', 'salesMode', 'transactionTypeString', 'postedStatusString', 'location', 'register', 'cashier', 'purchase'];

  constructor(
    private _reportService: ReportsService,
    private _bs: BaseService,
    private _abd: AppBaseDataService,
    private _spinner: NgxSpinnerService,
    private _router: Router,
    public _filterService: FilterServiceService,
  ) { }

  ngOnInit(): void {
    this._globals.componentName = 'Sales Orders'
    this.setDefaultFilters()
    this.setDefaultViewMode()
    window.addEventListener('resize', () => this.setDefaultViewMode())
  }

  private setDefaultFilters(): void {
    if (!this._filterService.selectedInvoiceStatus) this._filterService.selectedInvoiceStatus = this._abd.invoiceStatus[0]
    if (!this._filterService.selectedTransactionType) this._filterService.selectedTransactionType = this._abd.transactionTypes[0]
    if (!this._filterService.selectedProductSellTypeFilter) this._filterService.selectedProductSellTypeFilter = this._abd.productSellTypeFilter[0]
  }

  setDefaultViewMode() {
    // Default to table on bigger screens (>= 992px), card on smaller screens
    this.viewMode = window.innerWidth >= 992 ? 'table' : 'card'
  }

  ngAfterViewInit() {
    //-- restore page number **begin
    let ti = null
    ti = setInterval(() => {
      //--
    
      if (!this._filterService.dateRange || this._filterService.dateRange.length < 1)
        this._filterService.initDates()

      this._filterService.selectedLocation = JSON.parse(JSON.stringify(this._abd.locations))
      this._filterService.selectedInvoiceStatus = this._abd.invoiceStatus[0]
      this._filterService.selectedInvoiceType = this._abd.invoiceType[0]
      this._filterService.selectedProductSellTypeFilter = this._abd.productSellTypeFilter[0]

      let ppages = this._filterService.getPages(this._globals.componentName)
      if (ppages) {
        let lastpage = parseInt(ppages.page)
        if (lastpage < 0) lastpage = 0
        if (lastpage > 0) {
          this.page = lastpage
          this.first = lastpage * this.rows
        }
      }

      let filter = this._filterService.getFilters(this._globals.componentName)
      if (filter) {
        this._filterService.dateRange[0] = new Date(filter.startDate)
        this._filterService.dateRange[1] = new Date(filter.endDate)
        this.page = filter.pageNo
        this.rows = filter.pageSize
        this.first = this.page * this.rows
        this._filterService.selectedTransactionType = this._abd.transactionTypes.find(f => f.id == filter.postedStatus)
        this._filterService.selectedInvoiceStatus = this._abd.invoiceStatus.find(f => f.id == filter.invoiceType)
        if (filter.filterValue) this._filterService.searchText = filter.filterValue
        this._filterService.selectedProductSellTypeFilter = this._abd.productSellTypeFilter.find(f => f.Value == filter.orderPlacement)

        this._filterService.selectedLocation = []
        for (let i = 0; i < filter.locationIds.length; i++) {
          const d = this._abd.locations.find(f => f.locationId == filter.locationIds[i])
          if(d) this._filterService.selectedLocation.push(d)
        }
        const dd = this._abd.locations
        //--
      }

      clearInterval(ti)
      this.getDataList()
      //--
    }, 200);
    //-- restore page number **end
  }

  ngOnDestroy() {
    this._globals.componentName = ''
  }

  makeParas() {
    this.page = this.page < 1 ? 0 : this.page
    this.rows = this.rows < 1 ? 10 : this.rows

    let locationIds = []
    if (this._filterService.selectedLocation && this._filterService.selectedLocation.length) {
      for (let i = 0; i < this._filterService.selectedLocation.length; i++)
        locationIds.push(this._filterService.selectedLocation[i].id)
    }


    const data = {
      startDate: formatDate(this._filterService.dateRange[0], 'MM/dd/yyyy', 'en-US'),
      endDate: formatDate(this._filterService.dateRange[1], 'MM/dd/yyyy', 'en-US'),
      locationIds: locationIds,
      pageNo: this.page,
      pageSize: this.rows,
      postedStatus: this._filterService.selectedInvoiceStatus?.id,
      invoiceType: this._filterService.selectedTransactionType ? this._filterService.selectedTransactionType.id : -1,
      filterValue: this._filterService.searchText,
      'orderPlacement': this._filterService.selectedProductSellTypeFilter?.Value,
      orderParam: this.orderParam,
      orderBy: this.orderBy
    }

    this._filterService.updateFilters(this._globals.componentName, data)
    this._filterService.updatePages(this._globals.componentName, { page: this.page, rows: this.rows })


    return JSON.stringify(data)
  }

  getDataList() {
    const paras = this.makeParas()
    if (!paras) return;

    this.isLoading = true
    let url = environment.OrderBaseURL + environment.FilterInvoiceHistory
    this._bs.httpPost(url, paras).subscribe(res => {
      // this._bs.httpGetParams(url, this.makeParas()).subscribe(res => {
      if (res.success) {
        this.dataList = Array.isArray(res.data) ? res.data : []
        this.totalRecords = res.totalRecords
        for (let i = 0; i < this.dataList.length; i++) {
          this.dataList[i].salesMode = this.dataList[i].isOnlineOrder ? 'Online' : 'In-Store'
        }
        //console.log('INVOICE', this.dataList)
      } else {
        this.dataList = []
        this.totalRecords = 0
      }
    }, () => {
      this.dataList = []
      this.totalRecords = 0
    }, () => {
      this.isLoading = false
    })
  }

  onPageChange(e) {
    e.totalRecords = this.totalRecords
    this.rows = e.rows
    this.page = e.page
    this.first = e.first
    this.selectedCardId = null
    this._abd.setOptionToLocalStorage(this._globals.componentName, 'last-page', e.page)
    //console.log(e)
    this.getDataList()
  }

  onRowSelected(e) {
    this._reportService.selectedInvoiceRow = this.selectedRow
    this._router.navigate([`app/sales-invoice-detail`])
  }
  actionButtonClick(item: any) {
    this._reportService.selectedInvoiceRow = item;
}
  ViewCustomer(){
    this._router.navigate([`app/sales-invoice-detail`])
  }

  callbackFuncFromFilter(event) {
    this.first = this.page * this.rows
    this.selectedCardId = null
    this.getDataList()
  }

  filterButtonPressed() {
    this.page = 0
    this.first = 0
    this.selectedCardId = null
    this.getDataList()
  }

  private get exportDataList() {
    return this.dataList.map(item => item.salesMode === 'Online'
      ? { ...item, register: '-', cashier: '-' }
      : item)
  }

  exportExcel() {
    this._abd.exportExcel(this.exportDataList, this.colheader[0], this.colflds, 'Inventory Overview')
  }

  exportPdf() {
    // let data = []

    // for (let i = 0; i < this.dataList.length; i++) {
    //   let row = []
    //   for (let j = 0; j < this.colflds.length; j++)
    //     row.push(this.dataList[i][this.colflds[j]])
    //   data.push(row)
    // }

    this._abd.exportPdf(this.exportDataList, this.colheader, this.colflds, 'Inventory Overview')
  }

  dummy() {
    this.paginator?.changePage(4)
  }

  customSort(e) {
    const last = this.orderParam
    switch (e.sortField) {

      case 'invoiceNumber':
        this.orderParam = 'InvoiceNumber'
        break;
      case 'date':
        this.orderParam = 'Dated'
        break;
      case 'customer':
        this.orderParam = 'CustomerName'
        break;
      case 'salesMode':
        this.orderParam = 'IsOnlineOrder'
        break;
      case 'transactionTypeString':
        this.orderParam = 'InvoiceType'
        break;
      case 'postedStatusString':
        this.orderParam = 'PostedStatus'
        break;
      case 'location':
        this.orderParam = 'LocationId'
        break;
      case 'register':
        this.orderParam = 'RegisterId'
        break;
      case 'cashier':
        this.orderParam = 'UserName'
        break;
      default:
        this.orderParam = ''
    }


    if (this.orderParam !== '') {
      this.orderBy = e.sortOrder == 1 ? 'asc' : 'desc'
      if (last !== this.orderParam) this.orderBy = 'asc'
      this.getDataList()
    }
  }


}
